import React from "react";
import { View, TouchableOpacity, Dimensions, StyleSheet } from "react-native";
import Text from "@components/AppText";
import colors from "@constants/color";

import t from "@constants/localization";

const PATH = "screens/SupportTree/components/ModalBottomButton";

const { width } = Dimensions.get("window");

const ModalBottomButton = ({ onSubmit }) => {
  return (
    <View
      style={{
        padding: 0.03 * width,
        borderTopWidth: StyleSheet.hairlineWidth,
        borderTopColor: "#e6e6e6",
      }}
    >
      <TouchableOpacity onPress={onSubmit}>
        <View
          style={{
            backgroundColor: "#E40046",
            width: "100%",
            height: 40,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 20,
          }}
        >
          <Text fontType="head2" style={{ color: colors.white }}>
            {t(`${PATH}/upload`)}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default ModalBottomButton;
